import React from 'react'

import { InsertionFlowScreensProps } from '../../../../../../../@types/props-types'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import Costs from '../../Costs'
import BaseRent from '../../fields/baseRent/BaseRent'
import FreeFromToUntil from '../../fields/freeFromToUntil/FreeFromToUntil'
import CourtageGroup from '../../fields/courtageGroup/CourtageGroup'
import AdditionalCosts from '../../fields/additionalCosts/AdditionalCosts'
import CostCalculationBox from '../../../../../../common/display/costCalculationBox/CostCalculationBox'
import { DefaultRentPriceTypeOption } from '../../../../../../../@types/dropdown-types'
import { PriceFieldType } from '../../../basicInfo/fields/priceField/PriceField'
import { formatNumberForCalc } from '../../../../../../../i18next/decimal'

interface CostsGarageRentProps {
  screenTooltip?: string
}

const CostsGarageRent: React.FC<InsertionFlowScreensProps<CostsScreenValidationResult> & CostsGarageRentProps> = (
  props
) => (
  <Costs {...props} headerKey='wizard.screen.costs.header2'>
    {(costsWrapperProps) => (
      <div className='grid grid-flex'>
        <div className='grid-item palm-one-whole two-fifth'>
          <BaseRent {...costsWrapperProps} />
          <AdditionalCosts {...costsWrapperProps} wrapperClassName='grid-item one-whole margin-top-l' />
          <FreeFromToUntil {...costsWrapperProps} wrapperClassName='grid-item one-whole margin-top-l' />
        </div>
        <div className='grid-item palm-one-whole three-fifth palm-margin-vertical-xl palm-padding-left-none padding-left-xl padding-top-m palm-margin-horizontal-xxl palm-order-one-down'>
          <CostCalculationBox
            additionalCostsValue={costsWrapperProps.insertionData.additionalCosts}
            priceValue={formatNumberForCalc(costsWrapperProps.insertionData.baseRent)}
            priceFieldType={PriceFieldType.COLD_RENT}
            priceType={costsWrapperProps.insertionData.priceType?.value as DefaultRentPriceTypeOption}
          />
        </div>
        <div className='grid-item one-whole margin-top-l'>
          <CourtageGroup {...costsWrapperProps} />
        </div>
      </div>
    )}
  </Costs>
)

export default CostsGarageRent
